"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getObjectValue = void 0;

function getObjectValue(obj, path, depth) {
  if (depth === void 0) {
    depth = Infinity;
  }

  if (depth < 1) {
    return obj;
  }

  var paths = String(path).split('.');

  var _a = __read(paths),
      head = _a[0],
      tail = _a.slice(1);

  var target = obj[head];

  if (paths.length <= 1) {
    return target;
  } else {
    if (typeof target === 'object') {
      // @ts-ignore
      return getObjectValue(target, tail.join('.'), depth - 1);
    } else {
      return target;
    }
  }
}

exports.getObjectValue = getObjectValue;